import { Address } from './address';
import { Area } from './area';
import { CenterDepartment } from './center-department';
import { CareSkill } from './employee/care-skill';
import { Employee } from './employee/employee';
import { ServiceCenter } from './service-center';

export class Beneficiaire {
	id: number;
	firstName: string;
	lastName: string;
	birthDate: string;
	phone: string;
	email: string;
	//    enumCompetence: string;
	careSkills: CareSkill[];
	preferredEmployee1: Employee;
	preferredEmployee2: Employee;
	preferredEmployee3: Employee;
	incompatibleEmployee1: Employee;
	incompatibleEmployee2: Employee;
	incompatibleEmployee3: Employee;
	address: Address;
	//    area: Area;
	serviceCenter: ServiceCenter;
	area: Area;
	centerDepartments: CenterDepartment[];

	constructor(
		options: {
			id?: number;
			firstName?: string;
			lastName?: string;
			birthDate?: string;
			phone?: string;
			email?: string;

			careSkills?: CareSkill[];
			address?: Address;
			preferredEmployee1?: Employee;
			preferredEmployee2?: Employee;
			preferredEmployee3?: Employee;
			incompatibleEmployee1?: Employee;
			incompatibleEmployee2?: Employee;
			incompatibleEmployee3?: Employee;
			area?: Area;
			centerDepartments?: CenterDepartment[];
		} = {}
	) {
		this.id = options.id || null;
		this.firstName = options.firstName || '';
		this.lastName = options.lastName || '';
		this.birthDate = options.birthDate || '';
		this.phone = options.phone || '';
		this.email = options.email || '';

		this.careSkills = options.careSkills || [];
		this.address = options.address || new Address();
		this.preferredEmployee1 = options.preferredEmployee1 || null;
		this.preferredEmployee2 = options.preferredEmployee2 || null;
		this.preferredEmployee3 = options.preferredEmployee3 || null;
		this.incompatibleEmployee1 = options.incompatibleEmployee1 || null;
		this.incompatibleEmployee2 = options.incompatibleEmployee2 || null;
		this.incompatibleEmployee3 = options.incompatibleEmployee3 || null;
		this.area = options.area || null;
		this.centerDepartments = options.centerDepartments || null;
	}
}
